<template lang="pug">
v-form#trfOnlForm(ref="trfOnlForm", @submit.prevent="doSave", lazy-validation)
  v-container(grid-list-md)
    v-layout(wrap)
      v-flex(lg3, md3, xs12)
        f-select-bank(
          v-model="list.data.bankCode",
          label="Bank Tujuan",
          :rules="[(v) => !!v || 'Masukan bank tujuan']",
          required,
          v-on:bank="bank = $event"
        )
      v-flex(lg2, md2, xs12)
        v-text-field(
          dense,
          v-model="list.customerId",
          v-numeric-only,
          label="No. Rekening",
          required,
          :rules="[(v) => !!v || 'Masukan no rekening', (v) => v.length > 3 || 'Nomor Rekening tidak boleh kurang dari 3 digit']"
        )
      v-flex(lg5, md5, xs12)
        v-text-field(
          dense,
          v-model="list.description",
          label="Nama",
          required,
          :rules="[(v) => !!v || 'Masukan nama rekening']"
        )
    .ma-2.menu-btn(justify-center, style="text-align: center")
      v-btn.mx-1(@click="doCancel") Kembali
        v-icon mdi-arrow-left
      v-btn.mx-1(
        color="btnprimary white--text",
        type="submit",
        form="trfOnlForm"
      ) Simpan
        v-icon mdi-content-save-outline
</template>
<script>
export default {
  name: "FTransferOnlineListForm",
  props: ["productId", "productGroup"],
  data() {
    return {
      list: {
        customerId: "",
        description: "",
        data: {
          bankCode: "",
          bankName: "",
          account: "",
          name: "",
        },
      },
      bank: null,
    };
  },
  mounted() {
    this.doReset();
  },
  methods: {
    doReset() {
      if (this.$refs.trfOnlForm) {
        this.$refs.trfOnlForm.resetValidation();
      }
      this.list = {
        customerId: "",
        description: "",
        data: {
          bankId: "",
          bankName: "",
          account: "",
          name: "",
        },
      };
      this.bank = null;
    },
    doSave() {
      if (this.$refs.trfOnlForm.validate()) {
        this.list.data.bankCode = this.bank.bankId;
        this.list.data.bankName = this.bank.initialName;
        this.list.data.account = this.list.customerId;
        this.list.data.name = this.list.description;
        this.$emit("list", this.list);
        this.doReset();
      }
    },
    doCancel() {
      this.$emit("cancel");
      this.doReset();
    },
  },
};
</script>